module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer002",
      "role": "doc-toc"
    }
  }, [_c('p', {
    staticClass: "TOCtitle"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('a', {
    attrs: {
      "href": "#/Seeking_the_Truth#_idTextAnchor001"
    }
  }, [_vm._v("Seeking the Truth")]), _vm._v(" by Terri Reed")]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/Trail_of_Danger#_idTextAnchor018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trail of Danger")]), _vm._v(" by Valerie Hansen")]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_vm._v("Excerpt from "), _c('a', {
    attrs: {
      "href": "#/Excerptone#_idTextAnchor040"
    }
  }, [_vm._v("True Blue K-9 Unit: Brooklyn Christmas")]), _vm._v(" by Laura Scott")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87a34ce8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table_of_Contents.vue
// module id = 63
// module chunks = 0